import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { WorkHoursReport } from '../../../components/reports/WorkHoursReport/WorkHoursReport';

export const WorkHoursReportPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle">Work Hours Report</h1>
      <WorkHoursReport />
    </Layout>
  );
};
